<template>
  <div id="filter-comment-type-visible-select">
    <label class="form-label">Тип видимости поста</label>
    <Multiselect @change="onChange" v-model="fields.type_visible_id" mode="single" placeholder="Не выбрано" noResultsText="Результатов не найдено" :searchable="true" :close-on-select="true" :options="getValues()" :trackBy="'title'" :max="1">
      <template v-slot:singlelabel="{ value }">
        <div class="multiselect-single-label option-item">
          <div class="item-name">{{ value.title }}</div>
        </div>
        </template>
        <template v-slot:option="{ option }">
        <div class="option-item">
          <div class="item-name">{{ option.title }}</div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import Multiselect from "@/plugins/multiselect"

export default defineComponent({
  name: "TypeVisible",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let typeVisibleValues = ref([])

    const fields = reactive({
      type_visible_id: props.data.val,
    })

    onMounted(async () => {
      fields.type_visible_id = props.data.val;

      let typeVisibles = [
        {
          id: null,
          title: "Не выбрано",
        },
        {
          id: 2,
          title: "Публичный",
        },
        {
          id: 1,
          title: "Приватный",
        },
      ]

      setValues(typeVisibles);
    })

    watch(() => props.data.val, (val) => {
      fields.type_visible_id = val
    })

    watch(() => props.data.typeVisibles, (val) => {
      setValues(val);
    })

    function setValues(items) {
      let filtered = []
      for (let prop in items) {
        let obj = items[prop]

        filtered.push({
          value: obj["id"],
          title: obj["title"],
        })
      }

      typeVisibleValues.value = filtered
    }

    function getValues() {
      return typeVisibleValues.value;
    }

    function onChange(value) {
      fields.type_visible_id = value
      emit("onChange", fields.type_visible_id)
    }

    return {
      onChange,
      getValues,
      fields,
    }
  }
})
</script>
